// Directive to make md-tooltip and other tooltips keyboard accessible
export default {
  bind(el, binding, vnode) {
    // Make element focusable
    if (!el.hasAttribute('tabindex')) {
      el.setAttribute('tabindex', '0');
    }

    // Add ARIA attributes for screen readers
    el.setAttribute('aria-describedby', binding.value || 'tooltip-content');
    el.setAttribute('role', 'button');
    el.setAttribute('aria-label', 'Show tooltip information');

    // Keyboard event handler
    const handleKeydown = (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        // Trigger mouse events to show tooltip
        const mouseEnterEvent = new MouseEvent('mouseenter', { bubbles: true });
        el.dispatchEvent(mouseEnterEvent);
      } else if (e.key === 'Escape') {
        e.preventDefault();
        // Hide tooltip
        const mouseLeaveEvent = new MouseEvent('mouseleave', { bubbles: true });
        el.dispatchEvent(mouseLeaveEvent);
        el.blur();
      }
    };

    // Focus handler
    const handleFocus = (e) => {
      // Show tooltip on focus
      setTimeout(() => {
        const mouseEnterEvent = new MouseEvent('mouseenter', { bubbles: true });
        el.dispatchEvent(mouseEnterEvent);
      }, 100);
    };

    // Blur handler
    const handleBlur = (e) => {
      // Hide tooltip on blur (with delay to allow for hover)
      setTimeout(() => {
        const mouseLeaveEvent = new MouseEvent('mouseleave', { bubbles: true });
        el.dispatchEvent(mouseLeaveEvent);
      }, 150);
    };

    // Add event listeners
    el.addEventListener('keydown', handleKeydown);
    el.addEventListener('focus', handleFocus);
    el.addEventListener('blur', handleBlur);

    // Store handlers for cleanup
    el._accessibleTooltipHandlers = {
      keydown: handleKeydown,
      focus: handleFocus,
      blur: handleBlur
    };
  },

  unbind(el) {
    // Clean up event listeners
    if (el._accessibleTooltipHandlers) {
      el.removeEventListener('keydown', el._accessibleTooltipHandlers.keydown);
      el.removeEventListener('focus', el._accessibleTooltipHandlers.focus);
      el.removeEventListener('blur', el._accessibleTooltipHandlers.blur);
      delete el._accessibleTooltipHandlers;
    }
  }
};


// WEBPACK FOOTER //
// ./src/directives/accessibleTooltip.js